import styled from "styled-components";

export const Container = styled.fieldset`
    border-radius: 5px;
    border-color: rgb(83, 82, 82);
    border-style: solid;
    border-width: 2px;
    margin-bottom: 10px;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 8px;
    box-sizing: border-box;
    background-color: white;
`;

export const StyledInput = styled.input`
    width: 99%;
    font-size: 18px;
    height: 30px;
    border: none;
    border-radius: 5px;
    padding-left: 8px;
    box-sizing: border-box;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "")};
    background-color: ${(props) => (props.backgroundColor ? "#eee" : "")};
    
    &:focus {
        outline: none;
    } 
`;

export const Legend = styled.legend`
    display: flex;
    align-items: center;
`;